<template>
  <div style="position: relative;">
    <div ref="chartBox" id="lineChart"></div>
<!--    // Y:年/ Q:季/  M:月/ W:周-->
    <span class="unitStyle">{{dateType == 'Y'?'(月)':(dateType == 'M' || dateType == 'W')?'(日)':''}}</span>
  </div>
</template>

<script>
import {
  sendRequest,
} from "../../api/order";
import isiOS from "../../utils/iosAn";
import { Toast } from "vant";
export default {
  name: "statisticsIndex",
  data() {
    return {
      dateType: "",
      userName: "",
      year: "",
      unit: "",
      extremeList: [], //展示最大值和最小值
      realMax: "", //展示最大值
      realMin: "", //展示最小值
      listAll: [],
      dataDetail: {},
    };
  },
  created() {
    var result = this.getUrlParams(location.href);
    console.log(result);
    this.dateType = result.dateType;
    this.userName = result.userName;
    this.year = result.y;
    this.unit = result.unit;
    if (this.dateType != "") {
      this.getList();
    }
  },
  mounted() {
    //拿app 的返回值
    window.NativeCallJS = (res) => {
      var _data = JSON.parse(res);
      console.log('NativeCallJS_data---',_data)
      this.dateType = _data.dateType;
      this.userName = _data.userName;
      this.year = _data.y;
      this.unit = _data.unit;
      this.getList();
    };
  },
  methods: {
    // 取url参数
    getUrlParams(url) {
      let urlStr = url.split("?")[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },
    changeData(type) {
      // Y:年/ Q:季/  M:月/ W:周
      this.dateType = type;
      this.listAll = [];
      if (type == "Q" || type == "W") {
        this.getQuarterWeekSearchFun();
      } else if (type == "Y" || type == "M") {
        this.getYearMonthSearchFun();
      }
    },
    //获取季度和周搜索条件
    getQuarterWeekSearchFun() {
      sendRequest({
        requestType: "POST", //接口 是 get 还是post
        url: "/homeChart/getQuarterWeekSearch", //接口地址
        isBody: true, // 必填get传false ,post传true
        body: {
          userName: "sizhen.wang",
          type: this.dateType,
        }, //post 接口的参数
        params: {},
      }).then((res) => {
        if (res.code === 20000) {
          this.listAll = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
    //获取年和月搜索条件
    getYearMonthSearchFun() {
      sendRequest({
        requestType: "POST", //接口 是 get 还是post
        url: "/homeChart/getYearMonthSearch", //接口地址
        isBody: true, // 必填get传false ,post传true
        body: {
          userName: "xiaobin.qiu",
          type: this.dateType,
        }, //post 接口的参数
        params: {},
      }).then((res) => {
        if (res.code === 20000) {
          this.listAll = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
    //选择明细
    drawStatisticalChart(row) {
      this.dataDetail = {};
      this.dataDetail = row;
      this.getList();
    },
    //获取详情数据
    getList() {
      let _data = {};
      if (this.dateType == "W") {
        _data = {
          dateType: this.dateType,
          userName: this.userName,
          y: this.year,
          w: this.unit,
        };
      } else if (this.dateType == "Q") {
        _data = {
          dateType: this.dateType,
          userName: this.userName,
          y: this.year,
          q: this.unit,
        };
      } else if (this.dateType == "M") {
        _data = {
          dateType: this.dateType,
          userName: this.userName,
          y: this.year,
          m: this.unit,
        };
      } else if (this.dateType == "Y") {
        _data = {
          dateType: this.dateType,
          userName: this.userName,
          y: this.year,
        };
      }
      sendRequest({
        requestType: "POST", //接口 是 get 还是post
        url: "/homeChart/selectDataList", //接口地址
        isBody: true, // 必填get传false ,post传true
        body: _data, //post 接口的参数
        params: {},
      }).then((res) => {
        if (res.code === 20000) {
          res.data.forEach((item) => {
            if (this.dateType == "Y") {
              item.x_name = item.m;
            } else if (this.dateType == "Q") {
              item.x_name = item.week;
            } else if (this.dateType == "M") {
              item.x_name = item.dayInt;
            } else if (this.dateType == "W") {
              item.x_name = item.dayDian;
            }
          });
          if (this.dateType == "Q" || this.dateType == "Y") {
            this.drawbarChart(res.data);
          } else if (this.dateType == "W" || this.dateType == "M") {
            this.drawLineChart(res.data);
          }
        } else {
          Toast(res.message);
        }
      });
    },
    //千位分隔符
    formatMoney(num, type) {
      if (/[^0-9\.]/.test(num)) {
        return "0";
      }
      if (num === null || num === "") {
        return "0";
      }
      num = num.toString().replace(/^(\d*)$/, "$1.");
      num = (num + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      num = num.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(num)) {
        num = num.replace(re, "$1,$2");
      }
      num = num.replace(/,(\d\d)$/, ".$1");
      if (type === 0) {
        // 不带小数位(默认是有小数位)
        var a = num.split(".");
        if (a[1] === "00") {
          num = a[0];
        }
      }
      var regexp = /(?:\.0*|(\.\d+?)0+)$/;
      num = num.replace(regexp, "$1");
      return num;
    },
    realMaxOrMinFun(data) {
      this.extremeList = [];
      // 最大值
      this.realMax = Math.max.apply(
        null,
        data.map(function (item) {
          return item.total_fee;
        })
      );
      // 最小值
      this.realMin = Math.min.apply(
        null,
        data.map(function (item) {
          return item.total_fee;
        })
      );
      data.length &&
        data.forEach((log, index) => {
          let extre = {};
          if(data.length == 1){
            if (log.total_fee === this.realMax) {
              extre.value = this.realMax;
              extre.xAxis = index;
              extre.yAxis = this.realMax;
              extre.name = "最大值";
              extre.symbol = "image://" + require("./high.png");
              extre.symbolSize = 12;
              if (this.dateType == "Y" || this.dateType == "Q") {
                extre.symbolOffset = [0, "-70%"];
              } else {
                extre.symbolOffset = [0, 0];
              }
              extre.label = {
                show: false,
              };
              extre.itemStyle = {
                borderColor: "#f00",
              };
              this.extremeList.push(extre);
            }
          }else {
            if (log.total_fee === this.realMin) {
              extre.value = this.realMin;
              extre.xAxis = index;
              extre.yAxis = this.realMin;
              extre.name = "最小值";
              extre.symbol = "image://" + require("./low.png");
              extre.symbolSize = 12;
              if (this.dateType == "Y" || this.dateType == "Q") {
                extre.symbolOffset = [0, "-70%"];
              } else {
                extre.symbolOffset = [0, "-11%"];
              }
              extre.label = {
                show: false,
              };
              extre.itemStyle = {
                borderColor: "#f00",
              };
              this.extremeList.push(extre);
            } else if (log.total_fee === this.realMax) {
              extre.value = this.realMax;
              extre.xAxis = index;
              extre.yAxis = this.realMax;
              extre.name = "最大值";
              extre.symbol = "image://" + require("./high.png");
              extre.symbolSize = 12;
              if (this.dateType == "Y" || this.dateType == "Q") {
                extre.symbolOffset = [0, "-70%"];
              } else {
                extre.symbolOffset = [0, 0];
              }
              extre.label = {
                show: false,
              };
              extre.itemStyle = {
                borderColor: "#f00",
              };
              this.extremeList.push(extre);
            }
          }
        });
    },
    //折线图
    drawLineChart(data) {
      this.chartLine = this.$echarts.init(document.getElementById("lineChart"));
      this.realMaxOrMinFun(data);
      this.chartLine.setOption(this.setLineData(data), true);
      var _this = this;
      if(data.length == 1){
        setTimeout(function(){
          _this.chartLine.dispatchAction({
            type: 'showTip',
            seriesIndex:0,  // 显示第几个series
            dataIndex: 0 // 显示第几个数据
          });
        })
      }
    },
    setLineData(_data) {
      let _this = this;
      let _max = _this.formatMoney(this.realMax);
      // let _max = _this.formatMoney(Math.ceil(this.realMax / 1000));
      var option = {
        dataZoom: [
          {
            start: 0,
            end: 100,
            minValueSpan: 5, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
            backgroundColor: "#fff",
            borderColor: "#D8E0EC",
            handleColor: "#A4A9BF",
            dataBackground: {
              areaStyle: {
                opacity: 0.1,
                color: "#4B84FF",
                width: 0.5
              },
              lineStyle: {
                opacity: 0.2,
                color: "#4B84FF",
                width: 0.5
              }
            },
            fillerColor: "rgb(74 131 255 / 20%)",
            show: true,
            type: "slider",
            throttle: "50", //设置触发视图刷新的频率。单位为毫秒（ms）。
            textStyle: false,
            handleSize: 2,
            showDetail: false,
            zoomLock: true,
            brushSelect: false,
          }, {
            type: "inside", //1平移 缩放
          }
        ],
        grid: {
          left: (_max.length<10)?'15%':(_max.length<11)?'17%':'19%',
          right: "7%",
          top: "15%",
          bottom: "25%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          backgroundColor: "#fff",
          extraCssText: "box-shadow: 0px 4px 10px 0px rgba(52,68,132,0.1500)",
          formatter: function (params) {
            var new_params = params[0],
              _day = "";
            var result = new_params.name;
            for (let i = 0; i < _data.length; i++) {
              if (_this.dateType == "W") {
                if (_data[i].dayDian == new_params.name) {
                  _day = _data[i].day;
                }
              } else if (_this.dateType == "M") {
                if (_data[i].dayInt == new_params.name) {
                  _day = _data[i].day;
                }
              }
            }
            let _value = _this.formatMoney(new_params.value);
            result = '<div class="tooltip-new-style"><p>' + _day + "</p><p>" + _value + "元</p></div>";
            return result;
          },
          // position: function (pt) {
          // return [pt[0] + 10, pt[1] + 10];
          // },
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: this.dateType == "W" ? true : false,
          axisLine: {
            lineStyle: {
              color: "#D8E0EC",
            },
          },
          axisLabel: {
            color: "#2F354D",
            fontSize: 9,
            // interval: 0,
          },
          axisTick: {
            inside: true,
            alignWithLabel: true,
          },
          data: _data.map(function (item) {
            return item.x_name;
          }),
        },
        yAxis: {
          name: "",
          type: "value",
          nameTextStyle: {  // y轴name的样式调整
            color: '#000',
            fontSize: 9,
          },
          axisLine: {
            show: false,
          },
          scale: true,
          axisLabel: {
            show: true,
            color: "#A4A9BF", // 标签文字的颜色
            formatter: function (value, index) {
              var new_val = _this.formatMoney(value);
              if(new_val == 0) {
                value = new_val + 'k'
              }else if(new_val.length <4){
                value = (new_val / 1000)+'k'
              }else {
                value = new_val.substr(0, new_val.length - 4) + 'k';
              }
              // value = _this.formatMoney(value);
              return value;
            },
          },
          axisTick: {
            show: false,
          },
          splitNumber: 5,
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            stack: "Total",
            barWidth: "100%",
            showSymbol: false,
            lineStyle: {
              color: "#4B84FF", //线的颜色
              width: 2,
              shadowOffsetX: 0, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(77,134,255,0.42)", //折线阴影颜色
            },
            //背景颜色
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(75,132,255,0.2)",
                },
                {
                  offset: 1,
                  color: "rgba(194,215,253,0)",
                },
              ]),
            },
            data: _data.map(function (item) {
              return item.total_fee;
            }),
            markPoint: {
              symbol: "none",
              data: this.extremeList,
            },
            emphasis: {
              // 鼠标移上去的时候，拐点的颜色和样式
              itemStyle: {
                color: "#0072FF", //颜色
                borderWidth: 2,
                borderColor: "#ffffff", //图形的描边颜色
              },
            },
            symbolSize: 3, //拐点大小
          },
        ],
      };
      return option;
    },
    //柱状图
    drawbarChart(data) {
      this.chartLine = this.$echarts.init(document.getElementById("lineChart"));
      this.realMaxOrMinFun(data);
      this.chartLine.setOption(this.setBarData(data), true);
      var _this = this;
      if(data.length == 1){
        setTimeout(function(){
          _this.chartLine.dispatchAction({
            type: 'showTip',
            seriesIndex:0,  // 显示第几个series
            dataIndex: 0 // 显示第几个数据
          });
        })
      }
    },
    setBarData(_data) {
      let _this = this;
      // let _max = _this.formatMoney(Math.ceil(this.realMax / 1000));
      let _max = _this.formatMoney(this.realMax);
      var option_bar = {
        dataZoom: [
          {
            start: 0,
            end: 100,
            minValueSpan: 5, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
            backgroundColor: "#fff",
            borderColor: "#D8E0EC",
            handleColor: "#A4A9BF",
            dataBackground: {
              areaStyle: {
                opacity: 0.1,
                color: "#4B84FF",
                width: 0.5
              },
              lineStyle: {
                opacity: 0.2,
                color: "#4B84FF",
                width: 0.5
              }
            },
            fillerColor: "rgb(74 131 255 / 20%)",
            show: true,
            type: "slider",
            throttle: "50", //设置触发视图刷新的频率。单位为毫秒（ms）。
            textStyle: false,
            handleSize: 2,
            showDetail: false,
            zoomLock: true,
            brushSelect: false
          }, {
            type: "inside", //1平移 缩放
          }
        ],
        grid: {
          left: (_max.length<8)?"13%":(_max.length<9)?"14%":(_max.length<10)?'16%':(_max.length<11)?'19%':'20%',
          right: "2%",
          top: "15%",
          bottom: "25%",
        },
        tooltip: {
          backgroundColor: "#fff",
          borderColor: "#fff",
          extraCssText: "box-shadow: 0px 4px 10px 0px rgba(52,68,132,0.1500)",
          formatter: function (params) {
            var result = params.name,
              _day = "";
            for (let i = 0; i < _data.length; i++) {
              if (_this.dateType == "Q") {
                if (_data[i].week == params.name) {
                  _day = _data[i].year;
                }
              } else if (_this.dateType == "Y") {
                if (_data[i].m == params.name) {
                  _day = _data[i].y;
                }
              }
            }
            if (params.data) {
              // let _value = _this.formatMoney(params.value / 1000);
              let _value = _this.formatMoney(params.value);
              if (_this.dateType == "Q") {
                result = '<div class="tooltip-new-style"><p>' + _day + params.name + "</p><p>" + _value + "元</p></div>";
              } else if (_this.dateType == "Y") {
                result = '<div class="tooltip-new-style"><p>' + _day + "年" + params.name + "月" + "</p><p>" + _value + "元</p></div>";
              }
            }
            return result;
          },
          // position: function (pt) {
          //   return [pt[0] + 10, pt[1] + 10];
          // },
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#D8E0EC",
            },
          },
          axisLabel: {
            color: "#2F354D",
            fontSize: 9,
            interval: 'auto',
          },
          axisTick: {
            alignWithLabel: true,
          },
          data: _data.map(function (item) {
            return item.x_name;
          }),
        },
        yAxis: {
          name: "",
          type: "value",
          nameTextStyle: {  // y轴name的样式调整
            color: '#000',
            fontSize: 8,
            padding:[0,20,0,0] // 加上padding可以调整其位置
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#A4A9BF", // 标签文字的颜色
            // margin: 2,
            formatter: function (value, index) {
              console.log('value',value)
              var new_val = _this.formatMoney(value);
              if(new_val == 0) {
                value = new_val + 'k'
              }else if(new_val.length <4){
                value = (new_val / 1000)+'k'
              }else {
                value = new_val.substr(0, new_val.length - 4) + 'k';
              }
              return value;
            },
          },
          axisTick: {
            show: false,
          },
          splitNumber: 5,
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            stack: "Total",
            barWidth: 16,
            barGap: "80%" /*多个并排柱子设置柱子之间的间距*/,
            barCategoryGap: "50%" /*多个并排柱子设置柱子之间的间距*/,
            data: _data.map(function (item) {
              return item.total_fee;
            }),
            itemStyle: {
              normal: {
                barBorderRadius: [4, 4, 0, 0],
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#4B84FF" },
                  { offset: 1, color: "#676FFF" },
                ]),
              },
            },
            markPoint: {
              symbol: "none",
              data: this.extremeList,
            },
            emphasis: {
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#67CFFF" },
                  { offset: 1, color: "#4B84FF" },
                ]),
              },
            },
          },
        ],
      };
      return option_bar;
    },
  },
};
</script>

<style lang="less" scoped>
#lineChart {
    /*margin-top: 54px;*/
    width: 99%;
    height: 290px;
}
.unitStyle {
  position: absolute;
  right: 0%;
  bottom: 17.5%;
  font-size: 9px;
  transform: scale(0.9);
}
.big-box {
  background: #f4f8fd;
  border-radius: 10px;
  margin: 16px;
  p:first-child {
    line-height: 70px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2f354d;
    padding-left: 24px;
  }
  p:nth-child(2) {
    background: linear-gradient(
      360deg,
      rgba(58, 74, 134, 0) 0%,
      rgba(58, 74, 134, 0.06) 100%
    );
    height: 20px;
  }
}
/deep/ .tooltip-new-style {
  padding: 8px 12px;
  p {
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 18px;
  }
  p:first-child {
    font-size: 12px;
    font-weight: 400;
    color: #a4a9bf;
  }
  p:last-child {
    font-size: 13px;
    font-weight: 500;
    color: #2f354d;
  }
}
.aaa {
  background: #ffaafe;
}
.bbb {
  background: #4d86ff;
}
</style>
